dealershipModule.factory('profitSettingsService',
    ['ProfitSetting', 'commonRESTCallService', 'AppSettings', 'imSessionVarsService', 'erateSessionVarsService', 'settingsCacheService', '$q',
        function(ProfitSetting, commonRESTCallService, AppSettings, imSessionVarsService, erateSessionVarsService, settingsCacheService, $q) {
    var api = {};

    api.getProfitSetting = function(productCode, dateOfSale) {
        var returnValPromise = $q.defer();
        if (!(dateOfSale instanceof Date)) {
            dateOfSale = new Date(dateOfSale);
        }

        var profitSetting = settingsCacheService.getCachedProfitSetting(productCode, dateOfSale);
        if (profitSetting) {
            returnValPromise.resolve(profitSetting);
        } else {
            var dateStr = dateOfSale.mmddyyyy();

            // The business services end point:
            //"GetProfitSetting/{applicationPartnerCode}/{dealerProviderCode}/{profileDate}/{productCode}",
            var getUrl = AppSettings.startSPANDealerSettingsURL + '/GetProfitSetting/' + imSessionVarsService.getCurrentProviderCode() + '/' +
                erateSessionVarsService.getCurrentDealerAccountCode() + '/' + dateStr + '/' + productCode;

            commonRESTCallService.getFromServer(getUrl)
                .success(function (responseData, status) {
                    var profitSettingValue = new ProfitSetting();
                    profitSettingValue.populateDataFromBusinessSvcs(responseData);
                    settingsCacheService.setCachedProfitSetting(productCode, dateOfSale, profitSettingValue);
                    returnValPromise.resolve(profitSettingValue);
                })
                .error(function (responseData, status) {
                    if (status === 404)
                        returnValPromise.reject("Profit setting not found");
                    else
                        returnValPromise.reject("Error retrieving profit setting");
                });
        }

        return returnValPromise.promise;
    };

    api.getAllProfitSettings = function(dateOfSale) {
        var returnValPromise = $q.defer();

        if (!(dateOfSale instanceof Date)) {
            dateOfSale = new Date(dateOfSale);
        }
        var dateStr = dateOfSale.mmddyyyy();

        settingsCacheService.clearCachedProfitSettings();

        // The business services end point:
        //"GetProfitSetting/{applicationPartnerCode}/{dealerProviderCode}/{profileDate}/{productCode}",
        var getUrl = AppSettings.startSPANDealerSettingsURL + '/GetProfitSettings/' + imSessionVarsService.getCurrentProviderCode() + '/' +
            erateSessionVarsService.getCurrentDealerAccountCode() + '/' + dateStr;

        commonRESTCallService.getFromServer(getUrl)
            .success(function(responseData, status) {
                var profitSettings = responseData.map(function(busSvcSetting) {
                    var profitSetting = new ProfitSetting();
                    profitSetting.populateDataFromBusinessSvcs(busSvcSetting);
                    return profitSetting;
                });

                profitSettings.forEach(function(profitSetting) {
                   settingsCacheService.setCachedProfitSetting(profitSetting.productData.ProductCode, dateOfSale, profitSetting);
                });
                returnValPromise.resolve(profitSettings);
            })
            .error(function(responseData, status) {
                returnValPromise.reject("Error retrieving profit setting");
            });

        return returnValPromise.promise;
    };

    api.setProfitSetting = function(productCode, dateOfSale, profitSetting) {
        var returnValPromise = $q.defer();

        if (!(dateOfSale instanceof Date)) {
            dateOfSale = new Date(dateOfSale);
        }
        var dateStr = dateOfSale.mmddyyyy();

        // The business services endpoint:
        //"SaveProfitSettings/{applicationPartnerCode}/{dealerProviderCode}/{profileDate}"
        var saveUrl = AppSettings.startSPANDealerSettingsURL + '/SaveProfitSettings/'+ imSessionVarsService.getCurrentProviderCode() + '/' +
            erateSessionVarsService.getCurrentDealerAccountCode() + '/' + dateStr;

        var profitSettingData = profitSetting.convertForBusinessSvcs();

        commonRESTCallService.postToServer(saveUrl, profitSettingData)
            .success(function(responseData, status) {
                settingsCacheService.setCachedProfitSetting(productCode, dateOfSale, profitSetting);
                returnValPromise.resolve(true);
            }).error(function(responseData, status) {
                returnValPromise.reject();
            });

        return returnValPromise.promise;
    };

    return api;
}]);